import React from "react";

const Check: React.FC<React.SVGProps<SVGSVGElement>> = ({
	width = 12,
	height = 12,
	...props
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="3"
			aria-label="Check icon"
			{...props}
		>
			<path d="M20 6L9 17l-5-5" />
		</svg>
	);
};

export default Check;